export const LOCALES = {
    ENGLISH: 'en-us',
    SPANISH: 'spa-us'
}